import styled from "styled-components";
import { ZIndexValues } from "../tools/ZIndexValues";

export const FloatingContentContainer = styled("div")`
   z-index: ${ZIndexValues.FloatingInteractiveElements};
`;
